<template>
  <JdsModal @close="$emit('close')">
    <template #header>
      <!-- We need this empty element so that header with close button gets rendered in UI perfectly -->
      <div></div>
    </template>
    <template #body>
      <div class="fe-h-full">
        <!-- Since JDS Modal by default has fe-relative class, so we are directly using fe-absolute here to position element relative to modal -->
        <div class="fe-w-1/2 fe-absolute fe-top-0 fe-left-0 fe-bottom-0">
          <div
            class="fe-relative fe-flex fe-flex-col fe-items-center fe-w-full fe-h-full fe-bg-black fe-rounded-l-large fe-overflow-hidden fe-justify-between"
          >
            <div class="fe-overflow-hidden fe-flex-1 fe-h-full">
              <div
                v-if="shouldOpenImageModal"
                class="fe-absolute fe-top-m fe-left-xs"
              >
                <JdsButton
                  @click="handleBackClick"
                  variant="tertiary"
                  size="small"
                  className="!fe-text-white"
                >
                  <template #icon>
                    <JdsIcon
                      name="ArrowLeftIcon"
                      size="m"
                      color="fe-text-white"
                      className="fe-mr-xs"
                    />
                  </template>
                  All photos
                </JdsButton>
              </div>

              <!-- Left Arrow -->
              <div
                class="fe-absolute fe-left-m fe-top-1/2"
                style="transform: translate(0, -50%)"
              >
                <JdsButton
                  @click="prevSlide"
                  :iconOnly="true"
                  variant="secondary"
                  size="small"
                  className="!fe-bg-white"
                >
                  <template #icon>
                    <JdsIcon
                      name="ChevronLeftIcon"
                      size="m"
                      color="fe-text-primary-60"
                    />
                  </template>
                </JdsButton>
              </div>

              <LazyImage
                className="fe-w-full fe-h-full"
                imgClassName="fe-object-contain"
                :src="currentImage.midResUrl"
                placeholder="none"
              />

              <!-- Right Arrow -->
              <div
                class="fe-absolute fe-right-m fe-top-1/2"
                style="transform: translate(0, -50%)"
              >
                <JdsButton
                  @click="nextSlide"
                  :iconOnly="true"
                  variant="secondary"
                  size="small"
                  className="!fe-bg-white"
                >
                  <template #icon>
                    <JdsIcon
                      name="ChevronRightIcon"
                      size="m"
                      color="fe-text-primary-60"
                    />
                  </template>
                </JdsButton>
              </div>
            </div>
          </div>
        </div>
        <div class="fe-flex fe-justify-end fe-h-full">
          <div class="fe-w-1/2 fe-pl-m">
            <div class="fe-h-full">
              <ReviewListItem
                v-if="currentVisibleReview"
                :review="currentVisibleReview"
                :hide-read-more-less-button="true"
                :is-lg-content-modal="true"
                class="fe-flex fe-flex-col fe-h-full"
                displayContext="content_modal"
                @click="handleThumbnailClick"
              />
            </div>
          </div>
        </div>
      </div>
    </template>
  </JdsModal>
</template>

<script>
  import LazyImage from "@/components/DesignSystem/LazyImage/LazyImage.vue"
  import JdsModal from "@/components/DesignSystem/JdsModal/JdsModal.vue"
  import JdsButton from "@/components/DesignSystem/JdsButton/JdsButton.vue"
  import ReviewListItem from "@/components/ReviewAndRating/ReviewList/ReviewListItem.vue"
  import GalleryImageModal from "@/components/ReviewAndRating/Gallery/GalleryImageModal.vue"
  import { modalMixin } from "@/mixins/modalMixin"
  import JdsIcon from "@/components/DesignSystem/JdsIcon/JdsIcon.vue"

  export default {
    name: "DesktopContentModal",
    components: {
      JdsModal,
      JdsButton,
      JdsIcon,
      LazyImage,
      ReviewListItem,
    },
    mixins: [modalMixin],
    props: {
      initialVisibleImageIndex: { type: Number, default: 0 },
      shouldOpenImageModal: { type: Boolean, default: false },
      currentVisibleReview: { type: Object, default: () => ({}) },
      showCurrentReviewOnly: { type: Boolean, default: false },
      hasNextReview: { type: Boolean, default: false },
      hasPrevReview: { type: Boolean, default: false },
    },
    data() {
      return {
        currentIndex: this.initialVisibleImageIndex,
        showPrevReview: false,
      }
    },
    watch: {
      currentVisibleReview() {
        // This is needed because when user view the next review, and if we don't change currentIndex, it will break because in next review there might not be any image on that index number
        if (!this.showPrevReview) {
          this.currentIndex = 0
        } else {
          // If user is moving to previous review, then we should show the last image of previous review
          this.currentIndex = this.images?.length - 1 || 0
          this.showPrevReview = false
        }
      },
      initialVisibleImageIndex(newVal) {
        this.currentIndex = newVal
      },
    },
    computed: {
      images() {
        return this.currentVisibleReview?.images
      },
      currentImage() {
        return this.images[this.currentIndex]
      },
    },
    methods: {
      setCurrentImage(index) {
        this.currentIndex = index
      },
      nextSlide() {
        if (this.currentIndex < this.images.length - 1) {
          this.currentIndex++
        } else if (!this.showCurrentReviewOnly) {
          this.$emit("nextReview")
        } else {
          this.currentIndex = 0
        }
      },
      prevSlide() {
        if (this.currentIndex > 0) {
          this.currentIndex--
        } else if (!this.showCurrentReviewOnly) {
          this.showPrevReview = true
          this.$emit("prevReview")
        } else {
          this.currentIndex = this.images.length - 1
        }
      },
      handleBackClick() {
        this.openModal(GalleryImageModal)
      },
      handleThumbnailClick(reviewData) {
        const findCurrentReviewIndex =
          reviewData?.currentReview?.images?.findIndex(
            (image) => image.id === reviewData?.currentImageId,
          )

        this.currentIndex =
          findCurrentReviewIndex === -1 ? 0 : findCurrentReviewIndex
      },
    },
  }
</script>
